import { RootState } from "../store";

import { StateFn } from "../types";
import { EmissionsState } from "./emissionsStore";
import { GridMode } from "./types";

const getStore = (state: RootState): EmissionsState => state.emissions;

// Selectors

const gridMode: StateFn<GridMode> = (state: RootState) =>
  getStore(state).gridMode;

export const emissionsSelectors = {
  gridMode,
};
